import React, {useState} from 'react';
import {Col, Container, Row} from "react-bootstrap";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination } from 'swiper/modules';

function Developmentprocess(props) {
    const [activeTab, setActiveTab] = useState(0);

    function displayTab(tabNumber) {
        setActiveTab(tabNumber);
    }

    return (
        <section className="developmemt_proces tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10}>
                        <div className="example" data-text="">
                            <h2>TekRevol’s Mobile App Development Process</h2>
                        </div>
                        <p>We are a mobile app development company who believes is completing all the homework before
                            starting any project. Whenever we get into a discussion with any potential client, we
                            discuss all the essentials including app objective, target audience, app’s USP, competitor
                            analysis, investment, and marketing efforts.</p>
                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="swiper_main">

                        <Swiper
                            // install Swiper modules
                            spaceBetween={0}
                            navigation={true}
                            loop={true}
                            modules={[Navigation, Pagination]}
                            breakpoints={{
                                1400: {
                                    slidesPerView: 4,
                                },
                                1200: {
                                    slidesPerView: 4,
                                },
                                900: {
                                    slidesPerView: 3,
                                },
                                500: {
                                    slidesPerView: 2,
                                },
                                100: {
                                    slidesPerView: 1,
                                }
                            }}

                        >
                            <SwiperSlide onClick={() => {
                                displayTab(0)
                            }} className={`tabs ${activeTab === 0 ? 'active' : ''}`}>
                                    <span>
                                        Project <br/>Discussion
                                    </span>
                            </SwiperSlide>
                            <SwiperSlide onClick={() => {
                                displayTab(1)
                            }} className={`tabs ${activeTab === 1 ? 'active' : ''}`}>
                                    <span>
                                       Business Insight <br/>&amp; Estimation
                                    </span>
                            </SwiperSlide>
                            <SwiperSlide onClick={() => {
                                displayTab(2)
                            }} className={`tabs ${activeTab === 2 ? 'active' : ''}`}>
                                    <span>
                                      Signing <br/>NDA
                                    </span>
                            </SwiperSlide>
                            <SwiperSlide onClick={() => {
                                displayTab(3)
                            }} className={`tabs ${activeTab === 3 ? 'active' : ''}`}>
                                    <span>
                                     UI/UX <br/>Design
                                    </span>
                            </SwiperSlide>
                            <SwiperSlide onClick={() => {
                                displayTab(4)
                            }} className={`tabs ${activeTab === 4 ? 'active' : ''}`}>
                                    <span>
                                   APP  <br/>Wireframing
                                    </span>
                            </SwiperSlide>
                        </Swiper>
{/*  
                        <div className="swiper-button-next"></div>
                        <div className="swiper-button-prev"></div> */}


                        <div
                            className={activeTab === 0 ? 'd-block tab_txt' : 'd-none tab_txt'}>
                            <p>We are a mobile app development company who believes is completing all the homework
                                before starting any project. Whenever we get into a discussion with any potential
                                client, we discuss all the essentials including app objective, target audience, app’s
                                USP, competitor analysis, investment, and marketing efforts. The idea is to acquire all
                                the expectations from the client’s end through an in-person meeting or a call
                                consultation.</p>
                        </div>
                        <div
                            className={activeTab === 1 ? 'd-block tab_txt' : 'd-none tab_txt'}>
                            <p> Our HTML5 development course includes acquiring a detailed understanding of your
                                business ideas and needs. We conduct a detailed study of your business requirements and
                                generate a precise assessment of the time and cost needed to develop a high-quality
                                HTML5 application that satisfies your demands.</p>
                        </div>
                        <div
                            className={activeTab === 2 ? 'd-block tab_txt' : 'd-none tab_txt'}>
                            <p> We recognize the importance of protecting your private data and info. As part of our
                                HTML5 development course, we guarantee that all our clients sign a Non-Disclosure
                                Agreement (NDA) in advance to our project initiation. This safeguards your sensitive
                                information and it stays secure and confidential.</p>
                        </div>
                        <div
                            className={activeTab === 3 ? 'd-block tab_txt' : 'd-none tab_txt'}>
                            <p>At TekRevol, we believe that an efficient and effective HTML5 application needs an
                                instinctive and appealing user interface (UI) and user experience (UX) layout. Our
                                creative team of skilled designers work hand-in-hand with our esteemed clients to
                                develop an HTML5 app that is visually alluring, easy to operate, and enhances the user
                                experience.</p>
                        </div>
                        <div
                            className={activeTab === 4 ? 'd-block tab_txt' : 'd-none tab_txt'}>
                            <p>Our HTML5 development procedure involves generating comprehensive wireframes that outline
                                the design, layout, and functionality of your application. This supports us to guarantee
                                that the final product meets your precise requirements and prospects. Our team works
                                closely with you to develop wireframes that precisely echo your idea for the HTML5
                                application.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Developmentprocess;